var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 35,
    viewBox: "0 0 143 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11_8513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1968 16.5318C25.323 15.5962 26.0391 14.1911 26.0391 12.6199C26.0391 11.0488 25.323 9.64365 24.1968 8.70811C24.3258 8.64611 24.45 8.57882 24.5684 8.5059C25.3154 8.04515 26.1971 7.77905 27.1414 7.77905C29.8366 7.77905 32.0214 9.94643 32.0214 12.6199C32.0214 15.2935 29.8366 17.4608 27.1414 17.4608C26.1971 17.4608 25.3154 17.1947 24.5684 16.734C24.45 16.6611 24.3258 16.5938 24.1968 16.5318Z",
    fill: "#E65F2B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_11_8513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8412 13.3833C23.3449 12.0145 23.2569 10.4424 22.465 9.08177C21.673 7.72114 20.3445 6.85943 18.8977 6.60782C18.9783 6.49014 19.0519 6.37025 19.1175 6.2484C19.5322 5.47889 20.1617 4.81112 20.9795 4.34272C23.3136 3.00595 26.2982 3.79925 27.6457 6.11461C28.9933 8.42997 28.1936 11.3906 25.8595 12.7274C25.0417 13.1958 24.144 13.4026 23.2648 13.3742C23.1256 13.3696 22.9841 13.373 22.8412 13.3833Z",
    fill: "#E65F2B"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_11_8513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0799 11.3273C19.8263 9.89205 18.9576 8.57419 17.586 7.78863C16.2144 7.00307 14.6296 6.91575 13.2498 7.41547C13.2602 7.27361 13.2636 7.13326 13.259 6.99518C13.2303 6.12305 13.4388 5.23254 13.911 4.42125C15.2586 2.10589 18.2431 1.31259 20.5772 2.64936C22.9112 3.98614 23.711 6.94678 22.3633 9.26216C21.8912 10.0734 21.218 10.6979 20.4423 11.1093C20.3195 11.1744 20.1986 11.2474 20.0799 11.3273Z",
    fill: "#E65F2B"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_11_8513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6508 10.9171C15.7077 9.79994 14.2912 9.08952 12.7074 9.08952C11.1235 9.08952 9.70702 9.79994 8.76394 10.9171C8.70147 10.7891 8.63363 10.6659 8.56009 10.5485C8.09564 9.80746 7.82739 8.93285 7.82739 7.99604C7.82739 5.32249 10.0122 3.15515 12.7074 3.15515C15.4025 3.15515 17.5873 5.32249 17.5873 7.99604C17.5873 8.93285 17.3191 9.80746 16.8547 10.5485C16.7811 10.6659 16.7132 10.7891 16.6508 10.9171Z",
    fill: "#E65F2B"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_11_8513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.477 12.2615C12.0972 11.7617 10.5123 11.8491 9.14067 12.6346C7.76905 13.4201 6.90038 14.738 6.64675 16.1732C6.52811 16.0933 6.40725 16.0203 6.28442 15.9552C5.50869 15.5438 4.83553 14.9194 4.36335 14.1081C3.01578 11.7927 3.81548 8.83211 6.14954 7.49532C8.4836 6.15853 11.4681 6.95184 12.8157 9.26722C13.2879 10.0785 13.4965 10.969 13.4677 11.8411C13.4632 11.9792 13.4665 12.1195 13.477 12.2615Z",
    fill: "#E65F2B"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_11_8513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4027 15.0013C9.9558 15.2529 8.62731 16.1146 7.83541 17.4752C7.0435 18.8359 6.95547 20.408 7.45923 21.7768C7.31622 21.7664 7.17471 21.7631 7.0355 21.7676C6.15634 21.7961 5.25864 21.5892 4.4408 21.1208C2.10675 19.784 1.30704 16.8234 2.65461 14.508C4.00217 12.1927 6.98672 11.3994 9.32077 12.7362C10.1386 13.2046 10.7681 13.8723 11.1828 14.6418C11.2484 14.7637 11.3221 14.8835 11.4027 15.0013Z",
    fill: "#E65F2B"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_11_8513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9872 18.4018C9.86102 19.3373 9.14483 20.7425 9.14483 22.3135C9.14483 23.8847 9.86102 25.2899 10.9872 26.2254C10.8581 26.2873 10.7339 26.3547 10.6156 26.4276C9.86863 26.8883 8.98693 27.1544 8.04257 27.1544C5.34744 27.1544 3.1626 24.9871 3.1626 22.3135C3.1626 19.64 5.34744 17.4727 8.04257 17.4727C8.98693 17.4727 9.86863 17.7388 10.6156 18.1995C10.7339 18.2725 10.8581 18.3397 10.9872 18.4018Z",
    fill: "#E65F2B"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_11_8513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3425 21.5514C11.8387 22.9202 11.9267 24.4923 12.7187 25.8529C13.5106 27.2136 14.8391 28.0753 16.2859 28.3269C16.2054 28.4446 16.1318 28.5645 16.0661 28.6864C15.6514 29.4559 15.0219 30.1236 14.2041 30.592C11.87 31.9288 8.88548 31.1355 7.53791 28.8201C6.19034 26.5047 6.99005 23.5442 9.3241 22.2073C10.1419 21.7389 11.0397 21.5321 11.9188 21.5606C12.058 21.5651 12.1995 21.5618 12.3425 21.5514Z",
    fill: "#E65F2B"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_11_8513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1062 23.6083C15.3598 25.0435 16.2285 26.3614 17.6001 27.1469C18.9717 27.9325 20.5566 28.0198 21.9365 27.5201C21.926 27.662 21.9227 27.8023 21.9272 27.9404C21.9559 28.8125 21.7474 29.703 21.2752 30.5143C19.9276 32.8297 16.9431 33.623 14.609 32.2862C12.2749 30.9494 11.4752 27.9888 12.8229 25.6734C13.295 24.8622 13.9682 24.2377 14.7439 23.8263C14.8667 23.7612 14.9876 23.6881 15.1062 23.6083Z",
    fill: "#E65F2B"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_11_8513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5342 24.0206C19.4773 25.1378 20.8938 25.8482 22.4776 25.8482C24.0615 25.8482 25.478 25.1378 26.4211 24.0206C26.4835 24.1487 26.5513 24.2719 26.6249 24.3892C27.0894 25.1302 27.3576 26.0049 27.3576 26.9417C27.3576 29.6152 25.1728 31.7826 22.4776 31.7826C19.7825 31.7826 17.5977 29.6152 17.5977 26.9417C17.5977 26.0049 17.8659 25.1302 18.3303 24.3892C18.4039 24.2719 18.4717 24.1487 18.5342 24.0206Z",
    fill: "#E65F2B"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_11_8513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7092 22.6758C23.089 23.1755 24.6739 23.0882 26.0455 22.3027C27.4171 21.5171 28.2858 20.1993 28.5394 18.764C28.658 18.8438 28.7789 18.9169 28.9017 18.9821C29.6775 19.3935 30.3506 20.0179 30.8228 20.8292C32.1704 23.1446 31.3707 26.1052 29.0367 27.442C26.7026 28.7787 23.7181 27.9855 22.3705 25.6701C21.8983 24.8588 21.6897 23.9683 21.7184 23.0962C21.723 22.9581 21.7197 22.8177 21.7092 22.6758Z",
    fill: "#E65F2B"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_11_8513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3511 17.4566C27.3502 17.4583 27.3492 17.46 27.3482 17.4617C26.5563 18.8223 25.2278 19.684 23.781 19.9356C23.8615 20.0533 23.9352 20.1732 24.0008 20.295C24.4155 21.0646 25.045 21.7323 25.8628 22.2007C28.1969 23.5375 31.1814 22.7442 32.529 20.4289C33.6843 18.4438 33.2613 15.9845 31.6464 14.4808C30.9369 16.1698 29.2905 17.3746 27.3511 17.4566Z",
    fill: "#E65F2B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1836 25.4656V8.46777H49.9981C53.6324 8.46777 56.0474 10.6775 56.0474 14.1256C56.0474 17.5495 53.6324 19.7592 49.9981 19.7592H46.7702V25.4656H43.1836ZM49.6633 11.5031H46.7702V16.7238H49.6633C51.337 16.7238 52.413 15.7283 52.413 14.1256C52.413 12.4987 51.337 11.5031 49.6633 11.5031Z",
    fill: "url(#paint0_linear_11_8513)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7046 12.9843H65.2785V16.0925H63.9395C61.931 16.0925 61.1659 17.4523 61.1659 19.3464V25.4656H57.7945V12.9843H60.855L61.1659 14.8541C61.8354 13.7371 62.7918 12.9843 64.7046 12.9843Z",
    fill: "url(#paint1_linear_11_8513)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3888 25.6113C68.4675 25.6113 65.9091 23.0616 65.9091 19.2249C65.9091 15.3883 68.4675 12.8386 72.3888 12.8386C76.3101 12.8386 78.8685 15.3883 78.8685 19.2249C78.8685 23.0859 76.3101 25.6113 72.3888 25.6113ZM72.3888 22.8188C74.2777 22.8188 75.4493 21.3375 75.4493 19.2249C75.4493 17.1124 74.2777 15.6311 72.3888 15.6311C70.4999 15.6311 69.3522 17.1124 69.3522 19.2249C69.3522 21.3375 70.4999 22.8188 72.3888 22.8188Z",
    fill: "url(#paint2_linear_11_8513)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4291 12.8386C97.9636 12.8386 99.9721 14.2956 99.9721 18.3022V25.4656H96.6007V18.4965C96.6007 16.6267 95.9312 15.6554 94.4727 15.6554C93.0141 15.6554 92.0338 16.7481 92.0338 18.6422V25.4656H88.6624V18.4965C88.6624 16.6267 87.993 15.6554 86.5105 15.6554C85.052 15.6554 84.0956 16.7967 84.0956 18.6664V25.4656H80.7242V12.9843H83.6652L83.976 14.5384C84.7172 13.5671 85.7932 12.8629 87.5865 12.8386C89.0928 12.8144 90.5035 13.3729 91.2687 14.9512C92.1295 13.6157 93.5641 12.8386 95.4291 12.8386Z",
    fill: "url(#paint3_linear_11_8513)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.806 22.5759H114.188V25.4656H112.467C110.721 25.4656 110.171 24.6157 110.195 23.4258C109.334 24.8099 108.091 25.6113 106.178 25.6113C103.524 25.6113 101.611 24.3243 101.611 21.9446C101.611 19.2978 103.572 17.7923 107.254 17.7923H109.693V17.1852C109.693 16.0682 108.904 15.3397 107.493 15.3397C106.178 15.3397 105.293 15.9468 105.15 16.8695H101.898C102.137 14.4413 104.337 12.8386 107.589 12.8386C111.032 12.8386 113.016 14.3927 113.016 17.3795V21.7989C113.016 22.4545 113.279 22.5759 113.806 22.5759ZM109.693 20.3177V20.0748H107.23C105.819 20.0748 105.007 20.6576 105.007 21.7018C105.007 22.5759 105.7 23.1344 106.824 23.1344C108.593 23.1344 109.669 22.0174 109.693 20.3177Z",
    fill: "url(#paint4_linear_11_8513)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124.53 14.7084L124.817 12.9843H127.782V25.1013C127.782 28.1852 125.917 30.4678 121.207 30.4678C117.788 30.4678 115.444 28.8894 115.277 25.9998H118.672C118.983 27.1896 119.916 27.8695 121.47 27.8695C123.359 27.8695 124.483 26.9225 124.483 24.9799V23.6687C123.67 24.7128 122.45 25.3927 120.729 25.3927C117.429 25.417 115.014 22.9645 115.014 19.1035C115.014 15.2912 117.429 12.8144 120.705 12.8144C122.474 12.8144 123.717 13.6157 124.53 14.7084ZM121.47 22.6488C123.311 22.6488 124.459 21.2161 124.459 19.1521C124.459 17.0638 123.311 15.5826 121.47 15.5826C119.629 15.5826 118.457 17.0395 118.457 19.1278C118.457 21.2161 119.629 22.6488 121.47 22.6488Z",
    fill: "url(#paint5_linear_11_8513)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M136.206 25.6113C132.117 25.6113 129.655 23.1102 129.655 19.2492C129.655 15.364 132.165 12.8386 135.967 12.8386C139.649 12.8386 142.136 15.1698 142.184 18.8364C142.184 19.2007 142.16 19.6135 142.088 20.002H133.169V20.172C133.241 21.9446 134.365 23.013 136.063 23.013C137.425 23.013 138.382 22.406 138.669 21.2404H141.992C141.61 23.6687 139.482 25.6113 136.206 25.6113ZM133.241 17.768H138.788C138.549 16.2382 137.521 15.3883 135.991 15.3883C134.532 15.3883 133.432 16.2868 133.241 17.768Z",
    fill: "url(#paint6_linear_11_8513)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11_8513",
    x: 22.1968,
    y: 5.77905,
    width: 11.8247,
    height: 13.6818,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11_8513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11_8513",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_11_8513",
    x: 16.8977,
    y: 1.69336,
    width: 13.4026,
    height: 13.6899,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11_8513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11_8513",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_11_8513",
    x: 11.2498,
    y: 0,
    width: 13.7683,
    height: 13.3273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11_8513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11_8513",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_11_8513",
    x: 5.82739,
    y: 1.15515,
    width: 13.76,
    height: 11.762,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11_8513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11_8513",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_11_8513",
    x: 1.70874,
    y: 4.84595,
    width: 13.7683,
    height: 13.3273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11_8513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11_8513",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_11_8513",
    x: 0,
    y: 10.0868,
    width: 13.4026,
    height: 13.6899,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11_8513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11_8513",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_11_8513",
    x: 1.1626,
    y: 15.4727,
    width: 11.8247,
    height: 13.6818,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11_8513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11_8513",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_11_8513",
    x: 4.8833,
    y: 19.5514,
    width: 13.4026,
    height: 13.6899,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11_8513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11_8513",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_11_8513",
    x: 10.1682,
    y: 21.6083,
    width: 13.7683,
    height: 13.3273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11_8513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11_8513",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_11_8513",
    x: 15.5977,
    y: 22.0206,
    width: 13.76,
    height: 11.762,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11_8513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11_8513",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_11_8513",
    x: 19.7092,
    y: 16.764,
    width: 13.7683,
    height: 13.3273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11_8513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11_8513",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_11_8513",
    x: 21.781,
    y: 12.4808,
    width: 13.4026,
    height: 12.3693,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11_8513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11_8513",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11_8513",
    x1: 92.6836,
    y1: 8.46777,
    x2: 92.6836,
    y2: 30.4678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E65F2B",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11_8513",
    x1: 92.6836,
    y1: 8.46777,
    x2: 92.6836,
    y2: 30.4678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E65F2B",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11_8513",
    x1: 92.6836,
    y1: 8.46777,
    x2: 92.6836,
    y2: 30.4678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E65F2B",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11_8513",
    x1: 92.6836,
    y1: 8.46777,
    x2: 92.6836,
    y2: 30.4678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E65F2B",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11_8513",
    x1: 92.6836,
    y1: 8.46777,
    x2: 92.6836,
    y2: 30.4678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E65F2B",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11_8513",
    x1: 92.6836,
    y1: 8.46777,
    x2: 92.6836,
    y2: 30.4678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E65F2B",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_11_8513",
    x1: 92.6836,
    y1: 8.46777,
    x2: 92.6836,
    y2: 30.4678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E65F2B",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c1f9cb594cd1a5e2692ef2dce29d9246.svg";
export { ForwardRef as ReactComponent };